import type {UseFormReturn} from 'react-hook-form';
import type {PropertyName} from '@/types/stock-card';
import {propertyNames} from '@/types/stock-card';
import type {ConfiguratorFieldValues} from './Configurator';
import PropertySelect from './PropertySelect';

type Props = {
    productLineCode: string;
    form: UseFormReturn<ConfiguratorFieldValues>;
    unlocked: boolean;
};

const propertyLabels: Record<PropertyName, string> = {
    model: 'Model',
    size: 'Size',
    ratio: 'Ratio',
    assemblyPosition: 'Assembly Position',
    faceSize: 'Face Size',
    mountBase: 'Mount Base',
    outFlange: 'Out Flange',
};

const PropertySelects = ({productLineCode, form, unlocked}: Props): JSX.Element => {
    const values = form.watch() as Partial<ConfiguratorFieldValues>;
    const selects = [];
    let previousValue: string | null | undefined = null;

    for (const property of propertyNames) {
        if (!unlocked && previousValue === undefined) {
            break;
        }

        previousValue = values[property];

        selects.push(
            <PropertySelect
                key={property}
                label={propertyLabels[property]}
                productLineCode={productLineCode}
                unlocked={unlocked}
                selectedProperties={values}
                name={property}
                form={form}
            />,
        );
    }

    return <>{selects}</>;
};

export default PropertySelects;
